// src/components/molecules/UserProfile/Edit/ActionButtons/ActionButtonsGroup.js

import React from "react";
import { Grid } from "@mui/material";
import CancelButton from "../../../../atoms/Profile/Edit/CancelButton";
import SaveChangesButton from "../../../../atoms/Profile/Edit/SaveChangesButton";

const ActionButtonsGroup = ({ handleCancel, handleSave }) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{ mt: 4, mb: 4 }}
      alignItems="center"
      justifyContent="flex-start"
    >
      <Grid item>
        <CancelButton onClick={handleCancel} />
      </Grid>
      <Grid item>
        <SaveChangesButton onClick={handleSave} />
      </Grid>
    </Grid>
  );
};

export default ActionButtonsGroup;
